import { render, staticRenderFns } from "./QnStat.vue?vue&type=template&id=096ab204&scoped=true&"
import script from "./QnStat.vue?vue&type=script&lang=js&"
export * from "./QnStat.vue?vue&type=script&lang=js&"
import style0 from "./QnStat.vue?vue&type=style&index=0&id=096ab204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ab204",
  null
  
)

export default component.exports